var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg75Completed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_706)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0000305176,
    y: 0.398804,
    width: 12,
    height: 5,
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_69_706",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.05176e-05 5.3988H12V10.3988H3.05176e-05V5.3988Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.05176e-05 5.3988H12V10.3988H3.05176e-05V5.3988Z",
    fill: "#FFE37F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05176e-05 5.6988H12V5.0988H3.05176e-05V5.6988Z",
    fill: "#F6F8FA",
    mask: "url(#path-3-inside-1_69_706)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_69_706",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.05176e-05 10.3988H12V15.3988H3.05176e-05V10.3988Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.05176e-05 10.3988H12V15.3988H3.05176e-05V10.3988Z",
    fill: "#FFE37F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05176e-05 10.6988H12V10.0988H3.05176e-05V10.6988Z",
    fill: "#F6F8FA",
    mask: "url(#path-5-inside-2_69_706)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-3_69_706",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.05176e-05 15.3988H12V20.3988H3.05176e-05V15.3988Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.05176e-05 15.3988H12V20.3988H3.05176e-05V15.3988Z",
    fill: "#FFE37F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05176e-05 15.6988H12V15.0988H3.05176e-05V15.6988Z",
    fill: "#F6F8FA",
    mask: "url(#path-7-inside-3_69_706)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_706"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0000305176,
    y: 0.398804,
    width: 12,
    height: 20,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg75Completed);
export default __webpack_public_path__ + "static/media/75Completed.039564b0c51af0a4d9dd5c2b6f0d6f40.svg";
export { ForwardRef as ReactComponent };